var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconManageAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0f4b73;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-241 -417)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(241 417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.875,3.375h0a17.492,17.492,0,0,0-17.4,15.657,16.864,16.864,0,0,0,0,3.685,17.492,17.492,0,0,0,17.4,15.657h0a17.5,17.5,0,0,0,0-35ZM32.3,30.811c-1.91-.724-5.006-1.784-6.933-2.356-.2-.059-.227-.076-.227-.9a4.788,4.788,0,0,1,.555-1.96,9.778,9.778,0,0,0,.774-2.659,5.911,5.911,0,0,0,1.144-2.768,3.692,3.692,0,0,0-.034-2.322,1.489,1.489,0,0,1-.05-.143,15.13,15.13,0,0,1,.261-3.264,6.011,6.011,0,0,0-1.254-4.316,6.431,6.431,0,0,0-4.922-2.356H20.143a6.423,6.423,0,0,0-4.88,2.356A5.986,5.986,0,0,0,14,14.439a15.129,15.129,0,0,1,.261,3.264c-.017.059-.034.1-.05.151a3.63,3.63,0,0,0-.034,2.322,6,6,0,0,0,1.144,2.768A10.182,10.182,0,0,0,16.1,25.6a4.7,4.7,0,0,1,.32,1.986c0,.833-.034.841-.219.9-1.994.589-4.956,1.632-6.731,2.339A15.143,15.143,0,0,1,31.585,10.165,15.144,15.144,0,0,1,32.3,30.811Z",
    transform: "translate(249.625 425.625)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManageAccount);
export default __webpack_public_path__ + "static/media/icon-ManageAccount.44128a447d0170d7e6062249db505259.svg";
export { ForwardRef as ReactComponent };